var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncognitoBrowser1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3C2.89543 3 2 3.89543 2 5V6.25H22V5C22 3.89543 21.1046 3 20 3H4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 7.75H2V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V7.75ZM7.83501 10.8508C8.22873 12.7904 9.94474 14.25 12 14.25C13.17 14.25 14.23 13.777 14.9988 13.0117L15.0052 13.0052L15.0118 12.9987C15.5866 12.4215 15.9966 11.68 16.165 10.8508C16.2474 10.4449 16.6432 10.1826 17.0492 10.265C17.4551 10.3474 17.7174 10.7433 17.635 11.1492C17.458 12.0209 17.0841 12.821 16.5616 13.5009L17.4801 14.4194C17.773 14.7123 17.773 15.1872 17.4801 15.4801C17.1872 15.773 16.7123 15.773 16.4194 15.4801L15.501 14.5617C14.7186 15.1631 13.7769 15.5678 12.75 15.7015V17C12.75 17.4142 12.4142 17.75 12 17.75C11.5858 17.75 11.25 17.4142 11.25 17V15.7015C10.2231 15.5678 9.28142 15.1631 8.49899 14.5617L7.58047 15.4802C7.28758 15.7731 6.8127 15.7731 6.51981 15.4802C6.22692 15.1873 6.22692 14.7124 6.51981 14.4195L7.43843 13.5009C6.9159 12.821 6.54193 12.0209 6.36499 11.1492C6.28259 10.7433 6.54487 10.3474 6.95081 10.265C7.35674 10.1826 7.75261 10.4449 7.83501 10.8508Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncognitoBrowser1);
export default __webpack_public_path__ + "static/media/incognito-browser-1.15cfa150c8d2e7cdb3c3bbc5ac4b91b3.svg";
export { ForwardRef as ReactComponent };